import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useTravelPageRollout() {
  return useCbhFlag(CbhFeatureFlag.TRAVEL_PAGE_ROLLOUT, {
    defaultValue: {
      enabled: false,
      maxDistanceMiles: 3000,
      pageSize: 100,
      travelPageUrl: "",
      iconName: "airplane-takeoff",
    },
  });
}
